import styled from 'styled-components';
import { white } from 'styles/Colors';

export const OrgInfoCardWrapper = styled.div`
  position: absolute;
  top: 17px;
  left: 14px;

  padding: 8px 0px 11px 13px;
  width: 216px;
  min-height: 54px;
  border-radius: 5px;
  background-color: rgba(216, 216, 216, 0.14);
  letter-spacing: 0.34px;
  color: ${white};
  overflow: hidden;
  text-align: left;
`;

export const StadiumName = styled.div`
  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
export const OrganizationName = styled.div`
  font-family: Lato;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const DualSystemBadge = styled.span`
  background-color: #009688;
  font-size: 11px;
  color: ${white};
  padding: 4px 8px;
  border-radius: 34px;
  font-weight: 600;
  line-height: 10px;
`;
